import { SkuCardLowestAskProps } from '@/types/props/components/skus';
import LoadingComponent from '../../../LoadingComponent';
import { toDe } from '@/utilites/sku-operations';

export default function SkuCardLowestAskDesktop({
  sku,
}: SkuCardLowestAskProps) {
  if (sku === null) {
    return (
      <LoadingComponent
        loading={true}
        as="span"
        componentProps={{
          className: 'font-size-22 text-secondary',
        }}
      >
        <span className="fw-bolder">--</span>
      </LoadingComponent>
    );
  }

  if (typeof sku.lowestAsk !== 'number' || sku.lowestAsk <= 0) {
    return (
      <span className="font-size-22 text-secondary">
        <span className="fw-bolder">--</span>
      </span>
    );
  }

  return <span className="font-size-22">{toDe(sku.lowestAsk)}</span>;
}
